export enum EPlanName {
  Appsumo = 'appsumo',
  Business = 'business',
  Enterprise = 'enterprise',
  Free = 'free',
  FreeUS = 'free_us',
  Premium = 'premium',
  Pro = 'pro',
  Starter = 'starter',
  SelfService99 = 'self_service_99',
  TrialEnded = 'trial_ended',
  NoAccess = 'no_access',
  SelfService = 'self_service',
  Agency = 'agency',
  PlgStarter = 'plg_starter',
  PlgProfessional = 'plg_professional',
  SlgStarter = 'slg_starter',
  SlgProfessional = 'slg_professional',
  SlgOrganisation = 'slg_organisation',
  Api = 'api',
}

export enum EBillingPeriod {
  Monthly = 'monthly',
  Annual = 'annual',
}

export const PAID_PLANS = [
  EPlanName.Premium,
  EPlanName.Appsumo,
  EPlanName.Business,
  EPlanName.Pro,
  EPlanName.Starter,
  EPlanName.Enterprise,
  EPlanName.SelfService99,
  EPlanName.SelfService,
  EPlanName.Agency,
  EPlanName.PlgStarter,
  EPlanName.PlgProfessional,
  EPlanName.SlgStarter,
  EPlanName.SlgProfessional,
  EPlanName.SlgOrganisation,
  EPlanName.Api,
]

export const FREE_PLANS = [EPlanName.Free, EPlanName.FreeUS, EPlanName.TrialEnded, EPlanName.NoAccess]

export const WORKFLOWS_ELIGIBLE_PLANS = [...PAID_PLANS, EPlanName.FreeUS]

export enum EPlanChangeType {
  Upgrade = 'upgrade',
  Downgrade = 'downgrade',
  Change = 'change',
}

export enum EContactProvider {
  Cognism = 'cognism',
  CognismFree = 'cognism_free',
  Hunter = 'hunter',
  Waterfall = 'waterfall',
}

export enum EFeatureNames {
  Abm = 'abm',
  ContactsProvider = 'contacts.provider',
  ContactsUsageLimit = 'contacts.usage.limit',
  ContactsUsageLimitSoft = 'contacts.usage.limit.soft',
  ContactsPhoneNumbersLimit = 'contacts.phoneNumbers.limit',
  DomainsLimit = 'domains.limit',
  ExportsCSV = 'exports.csv',
  ExportsWorkflow = 'exports.workflow',
  LeadsLimit = 'leads.limit',
  LeadsLimitTier1 = 'leads.limit.tier1',
  LeadsLimitTier2 = 'leads.limit.tier2',
  LeadsLimitTier3 = 'leads.limit.tier3',
  LeadsLimitTier4 = 'leads.limit.tier4',
  LeadsLimitTier5 = 'leads.limit.tier5',
  LeadsLimitTier6 = 'leads.limit.tier6',
  LeadsLimitTier7 = 'leads.limit.tier7',
  LeadsLimitTier8 = 'leads.limit.tier8',
  LeadsLimitTier9 = 'leads.limit.tier9',
  ContactsUsageLimitTier1 = 'contacts.usage.limit.tier1',
  ContactsUsageLimitTier2 = 'contacts.usage.limit.tier2',
  ContactsUsageLimitTier3 = 'contacts.usage.limit.tier3',
  ContactsUsageLimitTier4 = 'contacts.usage.limit.tier4',
  ContactsUsageLimitTier5 = 'contacts.usage.limit.tier5',
  ContactsUsageLimitTier6 = 'contacts.usage.limit.tier6',
  ContactsUsageLimitTier7 = 'contacts.usage.limit.tier7',
  ContactsUsageLimitTier8 = 'contacts.usage.limit.tier8',
  ContactsUsageLimitTier9 = 'contacts.usage.limit.tier9',
  ContactsPhoneNumbersLimitTier1 = 'contacts.phoneNumbers.limit.tier1',
  ContactsPhoneNumbersLimitTier2 = 'contacts.phoneNumbers.limit.tier2',
  ContactsPhoneNumbersLimitTier3 = 'contacts.phoneNumbers.limit.tier3',
  ContactsPhoneNumbersLimitTier4 = 'contacts.phoneNumbers.limit.tier4',
  ContactsPhoneNumbersLimitTier5 = 'contacts.phoneNumbers.limit.tier5',
  ContactsPhoneNumbersLimitTier6 = 'contacts.phoneNumbers.limit.tier6',
  ContactsPhoneNumbersLimitTier7 = 'contacts.phoneNumbers.limit.tier7',
  ContactsPhoneNumbersLimitTier8 = 'contacts.phoneNumbers.limit.tier8',
  ContactsPhoneNumbersLimitTier9 = 'contacts.phoneNumbers.limit.tier9',
  ProfileActivity = 'profile.activity',
  RevealApi = 'revealApi',
  RoiDashboard = 'roi.dashboard',
  Roles = 'roles',
  Segments = 'segments',
  Support = 'support',
  WorkflowDelay = 'workflow.delay',
  WorkflowEmail = 'workflow.email',
  WorkflowEmailCsv = 'workflow.email.csv',
  WorkflowGoogleSheets = 'workflow.google_sheets',
  WorkflowHubspot = 'workflow.hubspot',
  WorkflowLinkedin = 'workflow.linkedin',
  WorkflowManualApproval = 'workflow.manual.approval',
  WorkflowMicrosoftTeams = 'workflow.microsoft_teams',
  WorkflowPipedrive = 'workflow.pipedrive',
  WorkflowSalesforce = 'workflow.salesforce',
  WorkflowSlack = 'workflow.slack',
  WorkflowWebhook = 'workflow.webhook',
  WorkflowAttio = 'workflow.attio',
  WorkflowClay = 'workflow.clay',
  WorkflowZapier = 'workflow.zapier',
  WorkflowN8n = 'workflow.n8n',
  Signals = 'signals',
  BomboraCompanies = 'bomboraCompanies',
  AppSecuritySettings = 'security.app',
  Outreach = 'outreach',
  OutreachSenders = 'outreach.senders',
  Prospector = 'prospector',
  MyProspects = 'myProspects',
}

export const REALTIME_WORKFLOW_FEATURES = [
  EFeatureNames.WorkflowHubspot,
  EFeatureNames.WorkflowPipedrive,
  EFeatureNames.WorkflowSalesforce,
  EFeatureNames.WorkflowSlack,
  EFeatureNames.WorkflowWebhook,
  EFeatureNames.WorkflowClay,
  EFeatureNames.WorkflowZapier,
  EFeatureNames.WorkflowMicrosoftTeams,
  EFeatureNames.WorkflowGoogleSheets,
  EFeatureNames.WorkflowLinkedin,
  EFeatureNames.WorkflowAttio,
  EFeatureNames.WorkflowN8n,
] as const

// Plan-or-override feature keys consumed by workflows-worker during lead processing.
// The lead_processing endpoint also resolves `contacts.usage.limit` from tier separately.
export const LEAD_PROCESSING_FEATURE_KEYS = [
  ...REALTIME_WORKFLOW_FEATURES,
  EFeatureNames.WorkflowDelay,
  EFeatureNames.WorkflowEmail,
  EFeatureNames.WorkflowEmailCsv,
  EFeatureNames.WorkflowManualApproval,
  EFeatureNames.Outreach,
  EFeatureNames.ContactsProvider,
  EFeatureNames.ContactsUsageLimitSoft,
] as const

export interface ICommonFeatures {
  [EFeatureNames.Abm]: boolean
  [EFeatureNames.ContactsProvider]: EContactProvider
  [EFeatureNames.ContactsUsageLimitSoft]: boolean
  [EFeatureNames.DomainsLimit]: number
  [EFeatureNames.ExportsCSV]: boolean
  [EFeatureNames.ExportsWorkflow]: boolean
  [EFeatureNames.ProfileActivity]: boolean
  [EFeatureNames.RevealApi]: boolean
  [EFeatureNames.Roles]: boolean
  [EFeatureNames.Segments]: boolean
  [EFeatureNames.Support]: boolean
  [EFeatureNames.WorkflowEmail]: boolean
  [EFeatureNames.WorkflowEmailCsv]: boolean
  [EFeatureNames.WorkflowHubspot]: boolean
  [EFeatureNames.WorkflowMicrosoftTeams]: boolean
  [EFeatureNames.WorkflowGoogleSheets]: boolean
  [EFeatureNames.WorkflowLinkedin]: boolean
  [EFeatureNames.WorkflowManualApproval]: boolean
  [EFeatureNames.WorkflowPipedrive]: boolean
  [EFeatureNames.WorkflowSalesforce]: boolean
  [EFeatureNames.WorkflowSlack]: boolean
  [EFeatureNames.WorkflowWebhook]: boolean
  [EFeatureNames.WorkflowAttio]: boolean
  [EFeatureNames.WorkflowClay]: boolean
  [EFeatureNames.WorkflowZapier]: boolean
  [EFeatureNames.WorkflowN8n]: boolean
  [EFeatureNames.WorkflowDelay]: boolean
  [EFeatureNames.Signals]: boolean
  [EFeatureNames.BomboraCompanies]: number
  [EFeatureNames.AppSecuritySettings]: boolean
  [EFeatureNames.Outreach]: boolean
  [EFeatureNames.OutreachSenders]?: number
  [EFeatureNames.Prospector]: boolean
  [EFeatureNames.MyProspects]: boolean
  [EFeatureNames.RoiDashboard]?: boolean
}

export interface IPlanFeatures extends ICommonFeatures {
  [EFeatureNames.LeadsLimitTier1]: number
  [EFeatureNames.LeadsLimitTier2]?: number
  [EFeatureNames.LeadsLimitTier3]?: number
  [EFeatureNames.LeadsLimitTier4]?: number
  [EFeatureNames.LeadsLimitTier5]?: number
  [EFeatureNames.LeadsLimitTier6]?: number
  [EFeatureNames.LeadsLimitTier7]?: number
  [EFeatureNames.LeadsLimitTier8]?: number
  [EFeatureNames.LeadsLimitTier9]?: number
  [EFeatureNames.ContactsUsageLimitTier1]?: number
  [EFeatureNames.ContactsUsageLimitTier2]?: number
  [EFeatureNames.ContactsUsageLimitTier3]?: number
  [EFeatureNames.ContactsUsageLimitTier4]?: number
  [EFeatureNames.ContactsUsageLimitTier5]?: number
  [EFeatureNames.ContactsUsageLimitTier6]?: number
  [EFeatureNames.ContactsUsageLimitTier7]?: number
  [EFeatureNames.ContactsUsageLimitTier8]?: number
  [EFeatureNames.ContactsUsageLimitTier9]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier1]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier2]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier3]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier4]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier5]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier6]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier7]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier8]?: number
  [EFeatureNames.ContactsPhoneNumbersLimitTier9]?: number
}

export interface ICustomerFeatures extends ICommonFeatures {
  // Resolved from the plan's per-tier value, which a plan need not have for every tier. Undefined
  // means the plan configures no limit, and is not the same as a cap of 0.
  [EFeatureNames.LeadsLimit]: number | undefined
  [EFeatureNames.ContactsUsageLimit]: number | undefined
  [EFeatureNames.ContactsPhoneNumbersLimit]: number | undefined
}

export const PAID_DOMAIN_LIMIT = 5
export const FREE_DOMAIN_LIMIT = 1

export interface IPlan {
  id: number
  name: EPlanName
  features: IPlanFeatures

  created_at: Date
  updated_at: Date
  deleted_at: Date | null
}

export type TierLevel = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9

export type PremiumContactsTierLevels = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9

export type RevealApiTierLevels = 1 | 2 | 3 | 4

export const ADD_ON_PRODUCT_NAMES = ['contactCredits', 'phoneCredits'] as const

export const SLG_ADD_ON_PRODUCT_NAMES = ['slgContactCredits', 'slgPhoneCredits'] as const

export type AddOnProductNames = (typeof ADD_ON_PRODUCT_NAMES)[number]

export type SlgAddOnProductNames = (typeof SLG_ADD_ON_PRODUCT_NAMES)[number]

export type SlgProductNames =
  | EPlanName.SlgStarter
  | EPlanName.SlgProfessional
  | EPlanName.SlgOrganisation
  | SlgAddOnProductNames

export type PlgProductNames = EPlanName.PlgStarter | EPlanName.PlgProfessional | AddOnProductNames

export type Products =
  | EPlanName.SelfService
  | 'contacts'
  | 'revealApi'
  | EPlanName.Agency
  | 'agencyContacts'
  | 'agencyRevealApi'
  | EPlanName.PlgStarter
  | EPlanName.PlgProfessional
  | EPlanName.Api
  | AddOnProductNames
  | SlgProductNames

type SelfServiceProduct = {
  name: EPlanName.SelfService
  tier: TierLevel
  quantity: 1
}

type AgencyProduct = {
  name: EPlanName.Agency
  tier: TierLevel
  quantity: 1
}

type ContactsProduct = {
  name: 'contacts'
  tier: PremiumContactsTierLevels
  quantity: 1
}

type AgencyContactsProduct = {
  name: 'agencyContacts'
  tier: PremiumContactsTierLevels
  quantity: 1
}

type RevealApiProduct = {
  name: 'revealApi'
  tier: RevealApiTierLevels
  quantity: 1
}

type AgencyRevealApiProduct = {
  name: 'agencyRevealApi'
  tier: RevealApiTierLevels
  quantity: 1
}

export type ApiPlanProduct = {
  name: EPlanName.Api
  tier: RevealApiTierLevels
  quantity: 1
}

type PlgProduct = {
  name: EPlanName.PlgStarter | EPlanName.PlgProfessional
  tier: TierLevel
  quantity: 1
}

type SlgProduct = {
  name: SlgProductNames
  tier: TierLevel
  quantity: 1
}

type PhoneCreditsProduct = {
  name: 'phoneCredits'
  tier: 1
  quantity: number
}

type ContactCreditsProduct = {
  name: 'contactCredits'
  tier: 1
  quantity: number
}

type SlgPhoneCreditsProduct = {
  name: 'slgPhoneCredits'
  tier: 1
  quantity: number
}

type SlgContactCreditsProduct = {
  name: 'slgContactCredits'
  tier: 1
  quantity: number
}

export type AddOnProducts = ContactCreditsProduct | PhoneCreditsProduct

export type SlgAddOnProducts = SlgContactCreditsProduct | SlgPhoneCreditsProduct

export type PlgProducts = PlgProduct | AddOnProducts

// Everything the subscription update endpoint accepts: base plans and add-ons alike.
export type SubscriptionUpdateProducts = PlgProducts | ApiPlanProduct

export type Product =
  | SelfServiceProduct
  | ContactsProduct
  | RevealApiProduct
  | AgencyProduct
  | AgencyContactsProduct
  | AgencyRevealApiProduct
  | ApiPlanProduct
  | PlgProduct
  | AddOnProducts
  | SlgProduct
  | SlgAddOnProducts

export type CheckoutPayload = {
  billingPeriod: EBillingPeriod
  products: Product[]
  promoId?: string
}

export type UpdateSubscriptionPayload = CheckoutPayload & {
  prorationDate: Date
}

export const PREMIUM_CONTACTS_TIERS = {
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
  6: 1000,
  7: 2000,
  8: 3000,
  9: 4000,
}

export const isApiPlan = (plan?: string) => plan === EPlanName.Api

export const REVEAL_API_TIERS = {
  1: 500,
  2: 1000,
  3: 2000,
  4: 5000,
}
